import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../../services/feedback.service';
import { MasterService } from '../../services/index';
import { StarratingComponent } from 'src/app/utils/starrating/starrating.component';
import { HttpClient } from '@angular/common/http';
import { Router,ActivatedRoute } from '@angular/router';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-fedrating',
  templateUrl: './fedrating.component.html',
  styleUrls: ['./fedrating.component.scss'],
    providers:[FeedbackService,MasterService]
})
export class FedratingComponent implements OnInit {

  
       ddlfeed=[];
       memberdetails:any[]=[];
       classdetails:any[]=[];
       closeResult: string;
       fedopts:any[]=[];
       fmodel:any={clid:'0',secid:'0',suid:'0',crid:'0'};
       student:boolean=true;
       staff:boolean=false;
       memberdash:any={};
       objfedhead:any={};
       objquesthead:any={};
       objquestopt:any={};
       selfed:any='0';
       objdetl:any={};
       modalOptions:NgbModalOptions;
       arrquest=[];
       arrdetails=[];
       arrcourse:any=[];
       classes:any=[];
       private modalRef: NgbModalRef;
       arrstatus=[{value:'Active'},{value:'Inactive'}];
       constructor(private http: HttpClient, private liservice: FeedbackService,private mservice: MasterService,private router: Router) { }
     
       
     
     
     
       ngOnInit(): void {
         
        //  this.getmemberdetails('selstu','');
        //  this.getclassdetails();
        //  this.memberdashcnts('dashcnts');
        // this.getfedbackhead(3);
        this.mascourse();
         this.getfedbackmod(0,'selall');
        
        
       }
mascourse() {
      this.mservice.mascourse()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrcourse = resultArray;
              this.fmodel.crid=resultArray[0].crid;
              this.masclass();
              //this.fmodel1.crid=resultArray[0].crid;
          },
          error => console.log("Error :: " + error)
          )
    }
    masclass() {
      this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              // this.massection();
              
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

        getfedbackmod(fbid,oprtype) {
       this.liservice.getfedbackhead(fbid,oprtype)
           .subscribe(
           resultArray => {
               console.log('members-result', resultArray);
               this.arrdetails = resultArray;

               this.selfed=resultArray[0].fbid;
                // this.getfedbackhead(this.selfed);
               
           },
           error => console.log("Error :: " + error)
           )
     }
     
       getfedbackhead(fbid,crid,clid) {
         this.liservice.getsumrating(fbid,crid,clid)
             .subscribe(
             resultArray => {
                 console.log('members-result', resultArray);
                 this.memberdetails = resultArray;
  
                
                 
             },
             error => console.log("Error :: " + error)
             )
       }

 generateStarRatingHTML(rating: number, maxRating: number = 5): string {
  let starsHtml = '';
  // const fullStar = '<span style="color:green" class="fa fa-star fachecked"></span>';
  // const emptyStar = '<span style="color:green" class="fa fa-star-o"></span>';
  // const halfStar = '<span style="color:green" class="fa fa-star-half-o fachecked"></span>'; // Requires Font Awesome v5+

  const fullStar = "<span style='color:green' class='fa fa-star fachecked'></span>";
  const emptyStar = "<span style='color:green' class='fa fa-star-o'></span>";
  const halfStar = "<span style='color:green' class='fa fa-star-half-o fachecked'></span>"; // Requires Font Awesome v5+
  const roundedRating = Math.round(rating * 2) / 2; // Round to nearest 0.5

  for (let i = 1; i <= maxRating; i++) {
    if (i <= roundedRating) {
      starsHtml += fullStar;
    } else if (i - 0.5 === roundedRating) {
      starsHtml += halfStar;
    } else {
      starsHtml += emptyStar;
    }
  }
  // console.log('rating',starsHtml);
  return starsHtml;
  
}


goToNewPage(fdid,emid,suid) {
  debugger
  // Merges the new 'filter' param with existing params like 'page' and 'sort'
  //  this.router.navigate(['/feedstfrating'], {
  //   queryParams: { fdid: fdid, emid:emid }
  // });
    this.router.navigate(['/app/feedstfrating',fdid,emid,suid]);
  // this.router.navigate(['/feedstfrating', {fdid: fdid, emid:emid, suid:suid}]);
}
     
      
     }
  
